import { EditAutomatedSegmentUploadScreen } from "types";
import { createScreen } from "utils/createScreen";

const EditAutomatedProgrammaticSegmentDefinition = createScreen({
  name: EditAutomatedSegmentUploadScreen,
  path: "/media-activation/programmatic-segments/automated/:id",
  routePath: ["/automated/:id"],
  accessPath: "programmaticCampaign.programmaticDomain",
});

export { EditAutomatedProgrammaticSegmentDefinition };
